import { useState, useCallback, useRef } from 'react';

interface ToastOptions {
  duration?: number;
  type?: 'success' | 'error' | 'info' | 'warning';
  errorDetails?: string[];
}

export const useToast = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [type, setType] = useState<'success' | 'error' | 'info' | 'warning'>('info');
  const [errorDetails, setErrorDetails] = useState<string[]>([]);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const hideToast = useCallback(() => {
    setIsVisible(false);
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }, []);

  const showToast = useCallback((newMessage: string, options: ToastOptions = {}) => {
    const { duration = 3000, type: newType = 'info', errorDetails: newErrorDetails = [] } = options;
    
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    setMessage(newMessage);
    setType(newType);
    setErrorDetails(newErrorDetails);
    setIsVisible(true);

    // Only auto-hide if there are no error details
    if (!newErrorDetails || newErrorDetails.length === 0) {
      timerRef.current = setTimeout(() => {
        setIsVisible(false);
        timerRef.current = null;
      }, duration);
    }
  }, []);

  return {
    showToast,
    hideToast,
    isVisible,
    message,
    type,
    errorDetails
  };
};

export default useToast; 